import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PermissionsTable } from 'src/components/common/form/permissions/table';
import { useTable } from 'src/hooks/use-table';
import { Filter, useFilteredPermissions } from './filter';
import { Filter as FilterType } from 'src/components/roles/form/types';
import styles from './index.module.css';
import { ActionType } from 'src/components/common/form/permissions/table/columns/actions';
import { SelectedPermission } from './types';

type AddedPermissionsTableProps = {
  permissions: SelectedPermission[];
  onChange: (id: string) => void;
};

const PAGINATION_LIMIT = 10;

export const AddedPermissionsTable = ({
  permissions,
  onChange,
}: AddedPermissionsTableProps) => {
  const { t } = useTranslation();

  const { page, setPage, filter, onFilterChange } = useTable<
    any,
    Record<any, any>
  >();

  const filteredPermissions = useFilteredPermissions({
    permissions,
    filter,
  });

  const data = filteredPermissions.slice(
    page * PAGINATION_LIMIT,
    (page + 1) * PAGINATION_LIMIT,
  );

  return (
    <div className="flex-1">
      <Filter
        onSubmit={onFilterChange}
        exclude={{ tagIds: true }}
        className={styles.filterWrapper}
        searchInputProps={{
          label: t('roles.form.permissions.filter.search.label-to-remove'),
        }}
      />

      <PermissionsTable
        data={data}
        className="mt-4"
        options={{
          page,
          count: filteredPermissions.length,
          rowsPerPage: PAGINATION_LIMIT,
          onChangePage: setPage,
        }}
        onChange={(id) => {
          onChange(id);

          if (data.length === 1 && page >= 1) {
            setPage(page - 1);
          }
        }}
        action={ActionType.Remove}
        forceShowingPagination
      />
    </div>
  );
};
